var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import * as R from "ramda";
import { getArtefactsListRequestArgs } from "./getArtefactsListRequestArgs.mjs";
import { ALL } from "./constants/types.mjs";
import { cartesian } from "./utils.mjs";
const agencyCodeParser = (agency) => R.startsWith("SDMX", R.prop("id", agency)) ? R.prop("code", agency) : R.prop("id", agency);
const getArtefactsListsRequestsArgs = (_a) => {
  var _b = _a, {
    agencies,
    categories,
    spaces,
    locale,
    types,
    versions
  } = _b, rest = __objRest(_b, [
    "agencies",
    "categories",
    "spaces",
    "locale",
    "types",
    "versions"
  ]);
  const nothingIsAll = R.when(R.isEmpty, R.always([ALL]));
  const nothingIsNothing = R.when(R.isEmpty, R.always([null]));
  const selection = R.evolve(
    {
      agencyIds: R.pipe(R.values, R.map(agencyCodeParser)),
      types: nothingIsAll,
      categories: R.values,
      spaces: R.pipe(
        R.values,
        R.map((sp) => __spreadProps(__spreadValues({}, sp), { url: sp.endpoint }))
      )
    },
    { spaces, agencyIds: agencies, categories, types, versions }
  );
  return R.pipe(
    R.map((space) => {
      const categories2 = R.pipe(
        R.filter(
          R.pipe(R.prop("spaceId"), R.anyPass([R.equals(space.id), R.isNil]))
        ),
        nothingIsNothing
      )(selection.categories);
      return R.pipe(R.map(R.prepend(space)))(
        cartesian([
          categories2,
          selection.types,
          nothingIsAll(selection.agencyIds),
          selection.versions
        ])
      );
    }),
    R.unnest,
    R.map(
      ([datasource, category, type, agencyId, version]) => getArtefactsListRequestArgs(__spreadValues({
        agencyIds: selection.agencyIds,
        datasource,
        category,
        type,
        agencyId,
        version,
        locale
      }, rest))
    )
  )(selection.spaces);
};
export {
  getArtefactsListsRequestsArgs
};
